export default {
	openMenu: '',
	remoteControlWindowIsOpen: false
	// returnRoute: undefined,
	// remoteControlWindowIsStillOpenAt: undefined
};
